module.exports = {
  GET_ORDERS: 'ott/reservationBanner/getOrders',
  GET_ORDERS_SUCCESS: 'ott/reservationBanner/getOrdersSuccess',
  GET_ORDERS_FAIL: 'ott/reservationBanner/getOrdersFail',
  ORDER_CANCEL: 'OTT/orders/orderCancel',
  ORDER_CANCEL_SUCCESS: 'OTT/orders/orderCancelSuccess',
};
